/* tslint:disable */
/* eslint-disable */
/**
 * Backend
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 *
 * @export
 * @enum {string}
 */
export enum InternshipStatus {
	Active = "Active",
	Inactive = "Inactive",
}

export function InternshipStatusFromJSON(json: any): InternshipStatus {
	return InternshipStatusFromJSONTyped(json, false);
}

export function InternshipStatusFromJSONTyped(
	json: any,
	ignoreDiscriminator: boolean
): InternshipStatus {
	return json as InternshipStatus;
}

export function InternshipStatusToJSON(value?: InternshipStatus | null): any {
	return value as any;
}
